import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useBusinessSizeLogic } from './hooks/useBusinessSizeLogic';
import { BusinessSizeForm } from './BusinessSizeForm';

export const EddBusinessSize = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useBusinessSizeLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.businessSize.title')}
        text={t('organic.businessSize.subtitle')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'>
        <BusinessSizeForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
